module.exports = __webpack_public_path__ + "static/media/discount_gradLine.aefde99b.svg";